import React from 'react';
import {TouchableOpacity} from 'react-native';
import {Props} from './model';
import {images} from '../../../../../assets/icons';
import {useTheme} from '../../../../theme';

export const Eye = (props: Props) => {
  const theme = useTheme();
  return (
    <TouchableOpacity
      testID={`password-eye-${props.showPassword ? 'show' : 'hide'}-${props.tag || 'untagged'}-id`}
      onPress={props.onPress}>
      {props.showPassword ? (
        <images.EyeOff height={24} width={24} color={theme.color.textColor} strokeWidth={0} />
      ) : (
        <images.Eye height={24} width={24} color={theme.color.textColor} />
      )}
    </TouchableOpacity>
  );
};
